<template>
  <div>
    <v-card class="fullForm">
      <div class="fullText">
        <b>طلبه گرامی:</b>
        <br />
        <br />
        شاخص ارزیابی ارزش انسانی در سخن متعالی پیامبر اکرم (صلی الله علیه وآله
        وسلم) صداقت راستگویی و پرهیز از دروغ و خیانت است.
        <br />
        اداره ارزشیابی اساتید ، پیشاپیش از اینکه شما جهت پاسخگویی به سوالات ذیل
        وقت می گذارید سپاسگزار بوده و به شما این اطمینان را می دهد که نظرات شما
        را دقیقا بررسی نموده و از نظرات شما جهت ارتقاء سطح کیفی تدریس اساتید و
        رفع نقاط ضعف کلاس به صورت جدی بهره برداری خواهد نمود.
        <br />
        در پیشگاه خداوند متعال متعهد باشیم در قضاوتمان نسبت به دیگران حب و بغض و
        کینه و کدورتها را دخالت ندهیم و خودمان را مدیون دیگران نکنیم.
        <br />
        <br />
      </div>
      <div style="width: 100%">
        <v-simple-checkbox
          v-model="checked"
          :ripple="false"
          @input="nextStep"
        ></v-simple-checkbox>
        <b>موارد فوق را مطالعه کرده و قبول دارم.</b>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    nextStep() {
      if (this.checked) this.$emit("nextStep");
    },
  },
};
</script>
<style scoped>
.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}
</style>
